import { ParametersEnum } from 'pages/common/types';
import { dimensionsErrors, SHOULD_BE_MORE_THEN_ZERO } from '../consts/dimensions';

export const projectConfigurationParamsValidation = async (
  inputValue: string,
  parameter: ParametersEnum
) => {
  if (inputValue === '0') return SHOULD_BE_MORE_THEN_ZERO;
  if (!inputValue) return dimensionsErrors[parameter]?.required;
  return undefined;
};
